export default __webpack_public_path__ + "media/zurb/img/lab/playground/responsive-email-templates/sidebar-aad2d69f358317427da6cb2d2c106693.jpg";